export default __webpack_public_path__ + "static/media/requiment-tick-icon.650e37c0.svg";